import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import AuditLogList from 'components/Lists/AuditLogList'
import Select from 'components/Inputs/Select'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, FilterContainer } from './styles'
import { DateTime } from 'luxon'

export default function AuditLogs () {
  const now = DateTime.now ().setLocale ('pt-BR')
  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [action, setAction] = useState (null)
  const [item, setItem] = useState (null)
  const [dateRange, setDateRange] = useState ([
    now.startOf ('month').toISODate (),
    now.toISODate ()
  ])
  const [auditLogs, setAuditLogs] = useState ([])
  const token = AuthService.getToken ()

  const ACTION_OPTIONS = [
    {label: 'Cadastro', value: 'create'},
    {label: 'Edição', value: 'update'},
    {label: 'Exclusão', value: 'delete'}
  ]

  const ITEM_OPTIONS = [
    {label: 'Membro', value: 'members'},
    {label: 'Salão', value: 'businesses'},
    {label: 'Profissional', value: 'professionals'},
    {label: 'Usuários bloqueados', value: 'blocked_users'},
    {label: 'Agendamento', value: 'schedules'},
    {label: 'Comanda', value: 'bills'},
    {label: 'Serviço', value: 'services'},
    {label: 'Produto', value: 'products'},
    {label: 'Pacote', value: 'bundles'},
    {label: 'Cartão fidelidade', value: 'loyalty_cards'},
    {label: 'Caixinha', value: 'tips'},
    {label: 'Categoria de serviço', value: 'service_categories'},
    {label: 'Reserva de agenda', value: 'schedule_reservations'},
    {label: 'Dias de trabalho do profissional', value: 'professionals_working_days'},
    {label: 'Serviços do profissional', value: 'professionals_services'},
    {label: 'Categorias de serviço do profissional', value: 'professionals_service_categories'},
    {label: 'Cartões fidelidade do cliente', value: 'customers_loyalty_cards'},
    {label: 'Suprimento', value: 'earnings'},
    {label: 'Sangria', value: 'expenses'},
    {label: 'Dívida/Desconto', value: 'debts'},
    {label: 'Crédito/Bônus', value: 'credits'},
    {label: 'Caixas', value: 'cash_registers'},
    {label: 'Serviços do salão', value: 'businesses_services'},
    {label: 'Produtos do salão', value: 'businesses_products'},
    {label: 'Clientes do salão', value: 'businesses_customers'},
    {label: 'Agenda do salão', value: 'business_working_days'},
    {label: 'Serviços da comanda', value: 'bills_services'},
    {label: 'Produtos da comanda', value: 'bills_products'},
    {label: 'Pacotes da comanda', value: 'bills_bundles'}
  ]

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    setLoading (true)
    getAuditLogs (dateRange, action, item, 1)
  }, [dateRange, action, item])

  const getAuditLogs = async (
    selectedDateRange = dateRange, selectedAction = action, selectedItem = item, pageNumber = page
  ) => {
    if (lastPage && pageNumber > lastPage) return

    try {
      if (pageNumber === 1) setLoading (true)

      const startDate = selectedDateRange ? selectedDateRange[0] : null
      const endDate = selectedDateRange ? selectedDateRange[1] : null
      let filters = `page=${pageNumber}`

      if (startDate === endDate) filters += `&date=${startDate}`
      else filters = `&start_date=${startDate}&end_date=${endDate}`
      if (selectedAction) filters += `&action=${selectedAction.value}`
      if (selectedItem) filters += `&table_name=${selectedItem.value}`

      const { data: auditLogsResponse } = await cutileiApi.get (`/audit_logs?${filters}`, requestConfig)

      const { data, meta } = auditLogsResponse
      const auditLogsData = pageNumber > 1 ? [...auditLogs, ...data] : data

      setAuditLogs (auditLogsData)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <AdminNavbar/>
      <FilterContainer>
        <DateInput
          value={dateRange}
          selectRange={true}
          onChange={setDateRange}
        />
        <Select
          placeholder='Ação...'
          value={action}
          isClearable={true}
          options={ACTION_OPTIONS}
          onChange={(_, option) => setAction (option)}
        />
        <Select
          placeholder='Item...'
          value={item}
          isClearable={true}
          options={ITEM_OPTIONS}
          onChange={(_, option) => setItem (option)}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 30}}/> : (
        <AuditLogList
          auditLogs={auditLogs}
          totalAuditLogs={total}
          hasMore={!(lastPage && page > lastPage)}
          onScroll={getAuditLogs}
        />
      )}
    </Container>
  )
}
